import AppDownloadLinkPanel from '../../components/molecules/panels/AppDownloadLinkPanel.vue'
import GifteeForBusinessIcon from '../../components/atoms/icons/GifteeForBusinessIcon.vue'
import AboutSnsButtons from '../../components/organism/statics/abouts/AboutSnsButtons.vue'
export default {
  components: { AppDownloadLinkPanel, GifteeForBusinessIcon, AboutSnsButtons }
}
